module.exports = __webpack_public_path__ + "img/yes.ab7a11f2.png";